import React from 'react'

const DueBar = (value) => {

    const dueBarValue = () => {

        const returnValue = `${70 * value.value}`

        const finalValue = Math.floor(returnValue)

        return finalValue

    }

    return (
        // HStack
        <div className="w-full h-[51px] flex flex-row items-center justify-center">

            {/* red bar */}
            {/* <div className="w-[50px] h-[12px]">
                <div className="w-[70px] h-[12px] bg-gray-300 rounded-l-full">
                    <div
                        className={`h-[12px] bg-red-400 rounded-l-full shadow-inner shadow-red-900`}
                        style={{ width: dueBarValue() }}
                    />
                </div>
            </div> */}

            {/* 'due' or 'late' */}
            {value.value !== 1 ?

                // due

                <div className="w-[50px] h-[30px] bg-slate-300 flex rounded-[8px] items-center justify-center right-0.5">

                    <p className={`font-tpThin text-black text-[18px]`}>
                        due
                    </p>

                </div>

                :

                <div className="w-[42.5px] h-[25px] bg-red-500 flex rounded-[6px] items-center justify-center right-0.5 shadow-sm shadow-gray-500">

                    <p className={`font-tpBold text-white text-[16px]`}>
                        late
                    </p>

                </div>

            }

        </div>
    )
}

export default DueBar